import { controls, currencyToNumber, grouped } from "../../controls";

const dept_emp_bill = {
  label: "Department Employee Bill",
  starting: true,
  url: "dept_emp_bill",
  pageLabel: "Department Employee Bill",
  pageType: "history",
  // filteraction: true,
  filter: [
    ...controls.displayText({
      tab: "filter", label: "Department",
      width: "col-sm-2",
      star: true
    }),
    ...controls.autoComplete({ tab: "filter", name: "department_code", controlType: "Department", isRequired: true, width: "col-sm-2", displayData: { department_display: "department_display" }, isRequired: true }),
    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2" }),

    ...controls.magicDateLabel({ label: "Date", target: "Salary Month" }),
    ...controls.magicDate({ dateType: "monthYear", default: "n", isRequired: true, name: "salary_date", width: "col-sm-2", displayFormat: "MMMM yyyy" }),
    ...controls.magicDateLabel({ label: "", width: "col-sm-2" }),

    ...controls.displayText({
      tab: "filter", label: "EmploymentGrade",
      width: "col-sm-2",

    }),
    ...controls.autoComplete({ tab: "filter", name: "employment_grade_code", controlType: "EmploymentGrade", width: "col-sm-2", isRequired: true }),
    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2" }),


  ],
  form: [],
  history: {
    perPage: 50,
    reportHeader: "Department Employee Bill",
    filterable: true,
    sortable: true,
    pivotable: true,
    //defaultsTo: 0,
    pdfProps: {
      pageSize: "A4", pageOrientation: "portrait",
      header: [
        [
          { source: 'fixed', value: 'Department' }, { source: 'fixed', value: '::' },
          { field: 'department_display' }, { source: 'fixed', value: '\n' },
          { field: "salary_date" }
        ]
      ],
    },
    // pivot: true,
    extraRows: {
      location: "top",
      fields: ["basic", "lp", "gp", "ca", "wa", "ot", "da", "hra", "spl_ot", "total", "pt", "gpf", "gis", "lic", "it", "fest_adv", "bl",
        "mc_loan", "otr_ded", "tot_ded", "payable"],
      grandtotal: { type: "fixed", displayIn: "emp_name", val: "Grand Total", count: true },
      // fixedTotals:[{by:"rows",rows:[1,2,3]}]
    },
    displayColumns: [
      {
        Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30,
        width132: { size: 3 }
      },
      {
        Header: "Emp Code",
        accessor: "emp_code"
      },

      {
        Header: "Emp Name",
        accessor: "emp_name",
        rwidth: "*",

      },
      {
        Header: "Basic/Fixpay",
        accessor: "basic",
      },
      {
        Header: "Lp",
        accessor: "lp",
      },
      {
        Header: "Gp",
        accessor: "gp",
      },
      {
        Header: "CA",
        accessor: "ca",
      },
      {
        Header: "WA",
        accessor: "wa",
      },
      {
        Header: "OT",
        accessor: "ot",
      },
      {
        Header: "DA",
        accessor: "da",
      },
      {
        Header: "HRA",
        accessor: "hra",
      },
      {
        Header: "Spl Ot",
        accessor: "spl_ot",
      },
      {
        Header: "Total",
        accessor: "total",
      },
      {
        Header: "PT",
        accessor: "pt",
      },
      {
        Header: "GPF",
        accessor: "gpf",
      },
      {
        Header: "GIS",
        accessor: "gis",
      },
      {
        Header: "LIC",
        accessor: "lic",
      },
      {
        Header: "IT",
        accessor: "it",
      },
      {
        Header: "Fest Adv",
        accessor: "fest_adv",
      },
      {
        Header: "Bank Loan",
        accessor: "bl",
      },
      {
        Header: "MC Loan",
        accessor: "mcl",
      },

      {
        Header: "House Rent",
        accessor: "house_rent",
      },

      {
        Header: "Revenue Stamp",
        accessor: "revenue_stamp",
      },
      {
        Header: "Otr Ded",
        accessor: "otr_ded",
      },
      {
        Header: "Tot Ded",
        accessor: "tot_ded",
      },
      {
        Header: "Payable",
        accessor: "payable",
      },
      {
        Header: "attendance",
        accessor: "attendance"
      },

      {
        Header: "Remark",
        accessor: "remark",

      },






    ]
  }
};

export default dept_emp_bill;